import TablesController from './tables_controller'
import $ from 'jquery'

export default class extends TablesController
  @values: {path: String}
  @targets: ['sortable', 'containment']

  # Sort assignment, problem set, & problem lists
  # Sort & group for problems & students
  sortableTargetConnected: (target) ->
    $(target).sortable(
      items: '.sortable', axis: 'y', cancel: 'a, button', tolerance: 'pointer', placeholder: 'tr',
      containment: @containmentTarget, connectWith: '.rowgroup.ui-sortable',
      start: ((event, ui) -> $(ui.placeholder).css('height', $(ui.item).css('height'))),
      out: ((event, ui) ->
        unless $(@).children().not('.ui-sortable-helper, .ui-sortable-placeholder').length
          $(@).append(ui.placeholder.clone().addClass('dummy'))),
      over: ((event, ui) -> $(@).find('.dummy').remove()),
      stop: ((event, ui) =>
        headers = 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/javascript', \
                  'X-CSRF-Token': $('meta[name=csrf-token]').prop('content')
        result = await fetch @pathValue,
                             method: 'PATCH', credentials: 'include', headers: headers, body: @serialize(target)
        new Function(await result.text())()
        @reshadeRows $(@containmentTarget).find('.tbody')))

  serialize: (target) ->
    table_name = @element.id.replace '_table', '_ids'
    if $(target).hasClass('rowgroup')
      $(@sortableTargets).map(-> $(@).find('.tr').not('.dummy').map((index, item) =>
        "#{table_name}[#{@id}][]=#{item.id}").get().join('&')).get().join('&')
    else
      $(target).sortable('serialize', key: "#{table_name}[]", expression: '(.*)')
